import { colorPrimary, colorSecondary } from 'src/app/themes/primaryThemeDefault'
import { IUIConfiguration } from '../models/store.model'
import { menuUrls } from './menu.constants'

export const defaultHomePage = '/home/menu'

export const APP_CHANNEL = 'app-channel'

export enum APP_CHANNEL_ACTIONS {
  LOGOUT = 'LOGOUT',
}

export const APP_IDLE_TIMEOUT_SECONDS = 60 * 15

export const defaultThemeConfig: IUIConfiguration = {
  primaryColor: colorPrimary,
  secondaryColor: colorSecondary,
  logo: '',
  cover: '',
}

export const LEFT_NAVIGATION_WIDTH = 260

export const MINIMIZED_LEFT_NAVIGATION_WIDTH = 80

export const MINUTES_TO_REFRESH_TOKEN = 30
export const USER_ROLE = {
  CLIENT: 'Client User',
  BANK: 'Bank User',
  IT_SYSTEM_ADMIN: 'IT System Admin',
}

export const FORMAT_DATE = 'MM/DD/YYYY'
export const FORMAT_DATE_TIME = 'MM/DD/YYYY hh:mm A'
export const FILE_TYPE_MAPPING: {
  [key: string]: string[]
} = {
  csv: ['text/csv'],
  excel: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
  pdf: ['application/pdf'],
  txt: ['text/plain'],
}

export const FILE_TYPE_DOWNLOADING: {
  [key: string]: string
} = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const FORMAT_TYPE_VALUE: {
  [key: string]: string
} = {
  csv: 'CSV',
  excel: 'Excel',
}

export const TEXT_QUALIFIER_VALUE: {
  [key: string]: string
} = {
  dash: 'Dash',
  doublequote: 'Double Quote',
}

export enum UserRoleIds {
  SUPER_ADMIN = '2a7918f0-70e0-4680-932b-f883f7307f6e',
}

export const ROUTES_WITH_BACK_BUTTON = [
  menuUrls.addClientSetup,
  menuUrls.viewClientSetup,
  menuUrls.editClientSetup,
  menuUrls.newAccount,
  menuUrls.editAccount,
  menuUrls.viewAccount,
  menuUrls.viewUsersForAccount,
  menuUrls.addFileMapping,
  menuUrls.copyFileMapping,
  menuUrls.viewUserRole,
  menuUrls.addUserRole,
  menuUrls.editUserRole,
  menuUrls.viewFileMapping,
  menuUrls.editFileMapping,
  menuUrls.addClientUserSetup,
  menuUrls.copyClientUserSetup,
  menuUrls.editClientUserSetup,
  menuUrls.copyBankUserSetup,
  menuUrls.addBankUserSetup,
  menuUrls.editBankUserSetup,
  menuUrls.resultScreen,
  menuUrls.viewErrorDetail,
  menuUrls.addPayeeMatchParameters,
  menuUrls.editPayeeMatchParameters,
  menuUrls.viewPayeeMatchParameters,
  menuUrls.achExceptionRulesAdd,
  menuUrls.achExceptionRulesEdit,
  menuUrls.achExceptionRulesView,
  menuUrls.viewAuditHistory,
  menuUrls.viewTransaction,
  menuUrls.searchResult,
  menuUrls.sentEmailTextsResults,
  menuUrls.exceptionItemsSearchResult,
  menuUrls.viewExceptionItem,
  menuUrls.exceptionItemAuditHistory,
]

export const ROUTES_HIDDEN_FAVORITE_ICON = [
  menuUrls.addClientSetup,
  menuUrls.viewClientSetup,
  menuUrls.editClientSetup,
  menuUrls.newAccount,
  menuUrls.editAccount,
  menuUrls.viewAccount,
  menuUrls.viewUsersForAccount,
  menuUrls.searchResult,
  menuUrls.resultScreen,
  menuUrls.viewErrorDetail,
  menuUrls.viewUserRole,
  menuUrls.addUserRole,
  menuUrls.editUserRole,
  menuUrls.addFileMapping,
  menuUrls.viewFileMapping,
  menuUrls.editFileMapping,
  menuUrls.copyFileMapping,
  menuUrls.addClientUserSetup,
  menuUrls.copyClientUserSetup,
  menuUrls.editClientUserSetup,
  menuUrls.copyBankUserSetup,
  menuUrls.addBankUserSetup,
  menuUrls.editBankUserSetup,
  menuUrls.addPayeeMatchParameters,
  menuUrls.editPayeeMatchParameters,
  menuUrls.viewPayeeMatchParameters,
  menuUrls.achExceptionRulesAdd,
  menuUrls.achExceptionRulesEdit,
  menuUrls.achExceptionRulesView,
  menuUrls.viewAuditHistory,
  menuUrls.viewTransaction,
  menuUrls.sentEmailTextsResults,
]
export const ROUTES_HIDDEN_HELP_ICON = [menuUrls.home]
